import React from 'react';
import '../../styles/LandingPage.scss';

const ProjectDescription: React.FC = () => (
  <div className="landing-page project-description-page">
    <div className="section-container">
      <h1 className="hero-title">About XM Deals</h1>
      <p className="hero-subtitle">
        XM Deals is an intelligent platform designed for institutional deal-making across real estate, corporate actions, and secondary transactions. Our mission is to connect qualified parties, accelerate deal cycles, and provide a secure, transparent, and compliant environment for complex transactions.
      </p>
      <section className="description-section">
        <h2>What is XM Deals?</h2>
        <p>
          XM Deals leverages AI-powered matching to connect buyers, sellers, and investors in real time. The platform supports a wide range of deal types, including real estate acquisitions, corporate M&A, IPOs, and secondary market trades. With a growing network of institutional participants, XM Deals streamlines the process of finding, negotiating, and closing deals.
        </p>
        <h2>Key Features</h2>
        <ul>
          <li><strong>Deal Matching Engine:</strong> AI-driven algorithms match parties based on deal criteria, preferences, and historical activity.</li>
          <li><strong>Real-Time Network:</strong> Access a dynamic network of institutional investors, developers, and market participants.</li>
          <li><strong>Security & Compliance:</strong> Enterprise-grade security, privacy controls, and full regulatory compliance for all transactions.</li>
          <li><strong>Multi-Sector Coverage:</strong> Real estate, corporate actions, and secondary transactions all in one platform.</li>
          <li><strong>Mobile Access:</strong> Manage deals and receive updates on the go with native mobile apps for iOS and Android.</li>
        </ul>
        <h2>Our Vision</h2>
        <p>
          We believe in a future where institutional deal-making is seamless, secure, and accessible from anywhere. XM Deals empowers market participants to close deals faster, with greater confidence and transparency.
        </p>
      </section>
    </div>
  </div>
);

export default ProjectDescription;
